module.exports = __webpack_public_path__ + "img/2_219.850cc56a.png";